import React from "react";
import "./Home.css";
import Logos from "../Logos";

export const Registration = () => {
  return (
    <div className="form-page-layout">
      <div className="form-layout">
        <h2>Registration</h2>
        <p>
          Registration for IEEE SmartComp 2025 is now open! You can register by
          completing the form below.
        </p>
        <h3>Important Dates</h3>
        <ul>
          <li>Registrations Open: 25th April 2025</li>
          <li>
            Author Registration Deadline:{" "}
            <span style={{ fontWeight: "bold" }}>12th May 2025</span>
          </li>
          <li>
            Early Bird Registration Deadline:{" "}
            <span style={{ fontWeight: "bold" }}>31st May 2025</span>
          </li>
        </ul>
        <h3>Pricing</h3>
        <table className="pricing-table">
          <tr>
            <th></th>
            <th>Early Registration (until 31st May 2025)</th>
            <th>Late Registration (after 1st June 2025)</th>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#d0dda6", fontWeight: "bold" }}>
              Full registration: IEEE members
            </td>
            <td>770 EUR</td>
            <td>950 EUR</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#d0dda6", fontWeight: "bold" }}>
              Full registration: non-member
            </td>
            <td>925 EUR</td>
            <td>1,140 EUR</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#d0dda6", fontWeight: "bold" }}>
              Student IEEE members
            </td>
            <td>540 EUR</td>
            <td>665 EUR</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#d0dda6", fontWeight: "bold" }}>
              Student non-member
            </td>
            <td>650 EUR</td>
            <td>800 EUR</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#d0dda6", fontWeight: "bold" }}>
              IEEE Life Member
            </td>
            <td>425 EUR</td>
            <td>525 EUR</td>
          </tr>
        </table>
        <h3>Policies</h3>
        <ol>
          <li style={{ fontWeight: "bold" }}>
            **Each paper (main, industry, workshop or poster/demo paper) must be
            accompanied by one full registration (non-student registration).**
          </li>
          <li>
            Each PhD forum paper must be accompanied by at least one student
            registration.
          </li>
          <li>
            If the paper is accepted for any of the conference tracks (main,
            industry, workshop, poster/demo paper, or PhD forum), at least one
            of the authors listed on the paper must attend the conference in
            person and present the paper according to the schedule provided in
            advance.
          </li>
          <li>
            Note that one full registration can cover one main/industry paper,
            up to two workshop papers, up to two demo/poster papers and one
            Ph.D. forum paper.
          </li>
          <li>Student registrations can cover only one PhD forum paper.</li>
          <li>
            All registrations are all-inclusive, including attendance to all
            conference events including the main conference, keynotes, all
            associated workshops, and other events associated to the event.
          </li>
          <li>
            There is no registration option for workshop-only registration.
          </li>

          <li>
            All registration includes lunch, coffee break, reception, and gala
            dinner.
          </li>
          <li>
            If you are not already an IEEE member, you may join IEEE by
            visiting:{" "}
            <a href="https://www.ieee.org/membership-application/join.html">
              https://www.ieee.org/membership-application/join.html
            </a>
            .
          </li>
          <li>
            {" "}
            Registration cancelled on/before 1st June, 2025 AoE is subject to
            100 EUR charge for processing fee. Registrations associated with a
            paper may not be cancelled. Registration may NOT be cancelled after
            1st June, 2025 AoE.
          </li>
          <li>
            {" "}
            For help with registration issues (e.g., registering multiple papers
            under one account), please contact the SmartComp 2025 Organisation
            Committee at ieeesmartcomp2025 at cs.ucc.ie
          </li>
          <li>
            For questions related to author submissions or other personal issues
            affecting compliance with these policies, contact the SmartComp 2025
            Organisation Committee at ieeesmartcomp2025 at cs.ucc.ie
          </li>
        </ol>
        {/*
        <p
          style={{
            marginBottom: "0px",
            paddingBottom: "0px",
            fontWeight: "bold",
          }}
        >
          Examples
        </p>
        <ol type="i" style={{ marginTop: "3px" }}>
          <li>one research paper = one full registration</li>
          <li>one poster paper = one full registration</li>
          <li>one PhD forum paper = one student registration</li>
          <li>one research paper & one WS paper = one full registration</li>
          <li>one research paper & one poster paper = one full registration</li>
          <li>
            one research paper & one PhD forum paper = one full registration
          </li>
          <li>
            one research paper & one poster paper & one PhD forum paper = one
            full registration
          </li>
          <li>two poster papers = one full registration</li>
          <li>one poster paper & one demo paper = one full registration</li>
          <li>
            one research paper & two poster papers = one full registration
          </li>
          <li>one research paper & two WS papers = one full registration</li>
          <li>
            two WS papers & one poster paper & one PhD forum paper = one full
            registration
          </li>
        </ol>
        */}
        <iframe
          src="https://conference.ucc.ie/11th-international-conference-on-smart-computing-ieee-smartcomp-2025/registration/Site/Register"
          style={{ width: "100%", height: "600px" }}
        />
      </div>
    </div>
  );
};
